import React, { useEffect } from 'react';

const AboutUs = () => {
  return (
    <section style={{padding: '2rem', lineHeight: '1.8', maxWidth: '900px', margin: '0 auto', marginTop:'10rem' }}>
      
      <p style={{ fontSize: '3rem', fontWeight: '500', marginBottom: '1rem', color:'#44413e' }}>About Us</p>
      <p>
        At <strong>Kidorise</strong>, we believe in making every little moment with your baby even more special.
        Thoughtfully designed for comfort, elegance, and functionality, our baby bedding and essentials bring together high-quality craftsmanship
        with minimal, timeless prints — creating spaces and memories that last.
      </p>

      <p>
        From swaddles and nappies to bedding and accessories, every piece is created with care, detail, and love — 
        to be part of your baby’s earliest and most cherished memories.
      </p>

      <p style={{ fontSize: '2rem', fontWeight: '500', marginTop: '2rem', color:'#44413e' }}>Meet the Founders</p>
      <p><em>A brand built on elegance, detail, and the love of a mother-daughter bond.</em></p>

      <p style={{ fontSize: '1.75rem', fontWeight: '500', marginTop: '1rem', color:'#44413e' }}>Built on Legacy. Grown with Love.</p>
      <p>
        Kidorise is a mother-daughter-led brand born out of a shared vision — to craft baby products that are as beautiful as they are functional.
      </p>

      <p>
        With over 15 years of experience in home furnishings and textiles, our founder (and mom) saw the opportunity to bring the same attention
        to quality and aesthetics into the world of baby essentials. Her signature elegance, technical expertise, and eye for detail shape every collection.
      </p>

      <p>
        One year ago, I joined her — drawn by everything she had built, and the clear gap in the market for stylish, international-quality baby products.
        While she leads production and design refinement, I focus on marketing and growth — and together, we dream, plan, and build the brand as a team.
      </p>

      <p>
        What makes it even more special is how aligned we are — in taste, in vision, in purpose. We push each other creatively, we balance each other’s strengths,
        and we’re both deeply invested in the joy our products bring to new moms.
      </p>

      <p style={{ fontSize: '1.75rem', fontWeight: '500', marginTop: '2rem', color:'#44413e' }}>What We Stand For</p>
      <ul style={{ paddingLeft: '1.5rem' }}>
        <li><strong> <i className="fa-solid fa-circle-dot" style={{fontSize:'1rem'}}></i> Craftsmanship you can feel:</strong> From hand-embroidery to custom detailing, every product is made with care.</li>
        <li><strong> <i className="fa-solid fa-circle-dot" style={{fontSize:'1rem'}}></i> Quality you can trust:</strong> We never compromise on fabric, finish, or comfort.</li>
        <li><strong> <i className="fa-solid fa-circle-dot" style={{fontSize:'1rem'}}></i> Designs that last:</strong> Our prints are meant to grow with your baby — soft, minimal, and always timeless.</li>
        <li><strong> <i className="fa-solid fa-circle-dot" style={{fontSize:'1rem'}}></i> Made for moms, too:</strong> Because the journey of motherhood deserves to be celebrated with pieces that feel as good as they look.</li>
      </ul>

      <p style={{ fontSize: '1.75rem', fontWeight: '500', marginTop: '2rem', color:'#44413e' }}>From Our Family to Yours</p>
      <p>
        Whether it’s your baby’s first swaddle or their favourite bedtime blanket, we’re grateful to be part of these little milestones.
        One mom once told us she’ll never forget the first set of swaddles she bought from us — that memory is now part of her journey.
      </p>

      <p>
        That’s exactly why we do what we do — to help create moments that stay with you.
      </p>

      <p style={{ marginTop: '2rem', fontStyle: 'italic' }}>
        With love,<br />
        <strong>Ramakant</strong><br />
        Founders, Kidorise
      </p>
    </section>
  );
};

export default AboutUs;
